.gripHandle {
    cursor: grab;
    color: var(--mantine-color-dimmed);
    display: flex;
    align-items: center;
}

.gripHandle:active {
    cursor: grabbing;
}

.unitSelectWrapper {
    position: relative;
    display: flex;
    align-items: center;
    flex: 0 0 5rem;
    width: 5rem;
}

.unitSelectLabel {
    white-space: nowrap;
    border-bottom: 1px dotted var(--mantine-color-dimmed);
    cursor: pointer;
}

.unitSelectOverlay {
    position: absolute;
    inset: 0;
    opacity: 0;
    cursor: pointer;
    width: 100%;
}

.quantityCell {
    display: flex;
    align-items: center;
    gap: calc(0.25rem * var(--mantine-scale));
    width: 100%;
}

.quantityInput {
    flex: 0 0 5rem;
    width: 5rem;
}

.quantityInput input {
    text-align: right;
}

.rateCell {
    display: flex;
    align-items: center;
    gap: calc(0.25rem * var(--mantine-scale));
    width: 100%;
}

.rateInput {
    flex: 0 0 7rem;
    width: 7rem;
}

.rateInput input {
    text-align: right;
}

.ratePrefixSpacer {
    visibility: hidden;
}

.headerRow,
.lineRow {
    display: grid;
    /* grip, qty, description, duration, rate ($ amount / unit), rental-period basis, ext, remove */
    grid-template-columns: 28px 5.75rem minmax(12rem, 1fr) 6.5rem 12.5rem 9rem 6.5rem 28px;
    column-gap: var(--mantine-spacing-sm);
    align-items: center;
    padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);
}

.headerRow {
    border-bottom: 1px solid var(--mantine-color-default-border);
    font-size: var(--mantine-font-size-xs);
    font-weight: 600;
    color: var(--mantine-color-dimmed);
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.lineRow {
    border-bottom: 1px solid var(--mantine-color-default-border);
}

.lineRowDragging {
    opacity: 0.5;
}

.extAmount {
    justify-self: end;
    text-align: right;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
}

.basisCell {
    font-variant-numeric: tabular-nums;
}

.extHeader {
    justify-self: end;
    text-align: right;
}
